import { Card, Form, Input, Typography } from "@payping/web-components";
import { isAlphabet } from "@payping/utils/string";
import { useAppTranslation } from "@/utils";
import { FormInstance } from "@payping/web-components/components/Form/types";
import React from "react";
import { SamanConfiguration } from "@/pages/DigitalAccount/Saman/Create";

interface Props {
  form: FormInstance<SamanConfiguration>;
  setRequestTitle: React.Dispatch<React.SetStateAction<string>>;
  setRequestDescription: React.Dispatch<React.SetStateAction<string>>;
}

const FirstStepSaman: React.FC<Props> = ({ form, setRequestTitle, setRequestDescription }) => {
  const { t } = useAppTranslation();
  return (
    <Form<SamanConfiguration>
      name={"SamanConfiguration"}
      onValuesChange={(changedValues) => {
        if ("title" in changedValues) {
          setRequestTitle(changedValues.title);
        }
        if ("description" in changedValues) {
          setRequestDescription(changedValues.description);
        }
      }}
      form={form}
      className="tw-w-full"
      layout={"vertical"}
    >
      <Card.Ant
        title={
          <Typography.Title type={"secondary"} level={5}>
            {t("digitalAccount.samanCreate.fileSetting")}
          </Typography.Title>
        }
      >
        <Form.Item
          label={t("digitalAccount.samanCreate.listName")}
          name={"title"}
          rules={[{ required: true, min: 5 }]}
          wrapperCol={{ lg: 6 }}
        >
          <Input className="tw-w-full" />
        </Form.Item>
        <Form.Item
          wrapperCol={{ lg: 10 }}
          name={"description"}
          label={t("description")}
          rules={[
            { required: true },
            {
              validator(_, value) {
                if (!isAlphabet(value, { withNumber: true }))
                  return Promise.reject(new Error(t("settlement.error.descriptionException")));
                if (value && value.length > 50) return Promise.reject(new Error(t("settlement.error.description")));
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder={t("digitalAccount.samanCreate.sampleDesSaman")} />
        </Form.Item>
      </Card.Ant>
    </Form>
  );
};

export default FirstStepSaman;
